import { render, staticRenderFns } from "./zy_jl.vue?vue&type=template&id=72bbe868&scoped=true&"
import script from "./zy_jl.vue?vue&type=script&lang=js&"
export * from "./zy_jl.vue?vue&type=script&lang=js&"
import style0 from "./zy_jl.vue?vue&type=style&index=0&id=72bbe868&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bbe868",
  null
  
)

export default component.exports